import React, { useEffect, useMemo, useState } from "react";
import { ContentfulTileProps, fetchResourceTilesByIds } from "../../utils/contentful-helpers";
import BookmarkMentorsCard from "../../components/Cards/BookmarkMentorsCard";
import TileBookmark from "../../components/Tile/TileBookmark";
import { useAppSelector } from "../../app/store";
import { fetchHomePageData } from "../../components/fetchHomePageData";
import { Mentor } from "../Mentorpal/MentorPal";
import "./Bookmarks.css";

const Bookmarks = () => {
  const mentorBookmarks = useAppSelector((state) => state.mentorBookmarks.bookmarks);
  const resourceBookmarks = useAppSelector((state) => state.resourceBookmarks.bookmarks);

  const bookmarkedMentorIds = useMemo(
    () => mentorBookmarks.map((bookmark) => bookmark.mentorId),
    [mentorBookmarks]
  );

  const bookmarkedResourceIds = useMemo(
    () => resourceBookmarks.map((bookmark) => bookmark.resourceId),
    [resourceBookmarks]
  );

  const [bookmarkedResources, setBookmarkedResources] = useState<ContentfulTileProps[]>([]);
  const [bookmarkedMentors, setBookmarkedMentors] = useState<Mentor[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resources = await fetchResourceTilesByIds(bookmarkedResourceIds);
        setBookmarkedResources(resources);
      } catch (error) {
        console.error("Failed to fetch bookmarked resources:", error);
      }
    };
    
    fetchData();
  }, [bookmarkedResourceIds]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const homePageData = await fetchHomePageData(process.env.PATHWAYS_ORG_ID);
        setBookmarkedMentors(homePageData.mentors.filter(
          (mentor) => bookmarkedMentorIds.some((id) => id === mentor._id)
        ));
      } catch (error) {
        console.error("Failed to fetch home page data:", error);
      }
    }

    fetchData();
  }, [bookmarkedMentorIds]);

  return (
    <>
      <div className="bookmarks">
        <div className="bookmark-section">
          <h2 className="favorite-resources">Favorite Resources</h2>
          <div className="mentor-bookmark-tiles">
            {bookmarkedResources.length === 0 ? (
              <p>No favorite resources yet.</p>
            ) : (
              bookmarkedResources.map((resource, index) => (
                <TileBookmark
                  key={resource.id || index}
                  title={resource.title} // fallback if Card expects `title`
                  description={resource.description}
                  thumbnail={resource.thumbnail}
                  url={resource.url}
                />
              ))
            )}
          </div>
        </div>
      </div>

      <div className="bookmarks">
        <div className="bookmark-section">
          <h2 className="favorite-mentors">Favorite Mentors</h2>
          <div className="mentor-bookmark-tiles">
            {bookmarkedMentors.length === 0 ? (
              <p>No favorite mentors yet.</p>
            ) : (
              bookmarkedMentors.map((mentor) => (
                <BookmarkMentorsCard
                  key={mentor._id}
                  name={mentor.name}
                  title={mentor.title}
                  thumbnail={mentor.thumbnail}
                  mentorUrl={mentor.mentorUrl}
                />
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Bookmarks;
